// Bali Auto Tour - Mock Data

export const siteInfo = {
  name: "Bali Auto Tour",
  domain: "baliautotour.com",
  email: "info@baliautotour.com",
  whatsapp: "+62 87862019000",
  whatsappLink: "https://wa.me/6287862019000",
  address: "Alliance Indonesia Building, Jl Himalaya I A no. 5 Denpasar Utara 80118 Bali Indonesia",
  googleMapsLink: "https://maps.google.com/?q=Alliance+Indonesia+Building+Denpasar+Bali"
};

export const translations = {
  en: {
    nav: {
      home: "Home",
      tours: "Tours",
      transfers: "Transfers",
      areas: "Destinations",
      gallery: "Gallery",
      about: "About Us",
      contact: "Contact"
    },
    hero: {
      title: "Discover the Magic of Bali",
      subtitle: "Premium tours and transfers with professional English and French-speaking drivers",
      cta: "Explore Tours",
      ctaSecondary: "Book Transfer"
    },
    services: {
      title: "Our Services",
      subtitle: "Tailored transportation and guided tours across Bali",
      tours: {
        title: "Guided Tours",
        description: "Explore Bali's hidden gems with our expert local guides"
      },
      transfers: {
        title: "Airport Transfers",
        description: "Comfortable and reliable airport pickup and drop-off"
      },
      roundtrip: {
        title: "Round Trip",
        description: "Flexible day trips to any destination in Bali"
      },
      private: {
        title: "Private Driver",
        description: "Your personal driver for a customized Bali experience"
      }
    },
    tours: {
      title: "Popular Tours",
      subtitle: "Handcrafted experiences to discover the best of Bali",
      duration: "Duration",
      from: "From",
      bookNow: "Book Now",
      includes: "Includes",
      highlights: "Highlights"
    },
    areas: {
      title: "Explore Bali by Region",
      subtitle: "Discover unique experiences in every corner of the island",
      south: {
        name: "South Bali",
        description: "Beaches, temples, and vibrant nightlife"
      },
      north: {
        name: "North Bali",
        description: "Waterfalls, dolphins, and peaceful retreats"
      },
      east: {
        name: "East Bali",
        description: "Ancient temples and traditional villages"
      },
      west: {
        name: "West Bali",
        description: "National parks and untouched nature"
      }
    },
    drivers: {
      title: "Professional Drivers",
      subtitle: "Choose the perfect driver for your journey",
      english: "English Speaking Driver",
      french: "French Speaking Driver",
      englishGuide: "Driver + English Speaking Guide",
      frenchGuide: "Driver + French Speaking Guide"
    },
    testimonials: {
      title: "What Our Guests Say",
      subtitle: "Real experiences from happy travelers"
    },
    gallery: {
      title: "Bali Gallery",
      subtitle: "Glimpses of paradise awaiting you"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know before your trip"
    },
    contact: {
      title: "Get in Touch",
      subtitle: "Ready to plan your Bali adventure? Contact us today!",
      email: "Email Us",
      whatsapp: "WhatsApp Us",
      address: "Visit Us"
    },
    footer: {
      description: "Your trusted partner for tours and transfers in Bali. Professional English and French-speaking drivers at your service.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact Info",
      rights: "All rights reserved."
    },
    cta: {
      title: "Ready for Your Bali Adventure?",
      subtitle: "Book your tour or transfer today and create unforgettable memories",
      button: "Contact Us Now"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      tours: "Excursions",
      transfers: "Transferts",
      areas: "Destinations",
      gallery: "Galerie",
      about: "À Propos",
      contact: "Contact"
    },
    hero: {
      title: "Découvrez la Magie de Bali",
      subtitle: "Excursions et transferts premium avec chauffeurs professionnels anglophones et francophones",
      cta: "Explorer les Excursions",
      ctaSecondary: "Réserver un Transfert"
    },
    services: {
      title: "Nos Services",
      subtitle: "Transport sur mesure et visites guidées à travers Bali",
      tours: {
        title: "Visites Guidées",
        description: "Explorez les trésors cachés de Bali avec nos guides locaux experts"
      },
      transfers: {
        title: "Transferts Aéroport",
        description: "Prise en charge et dépose à l'aéroport confortables et fiables"
      },
      roundtrip: {
        title: "Aller-Retour",
        description: "Excursions flexibles vers n'importe quelle destination à Bali"
      },
      private: {
        title: "Chauffeur Privé",
        description: "Votre chauffeur personnel pour une expérience balinaise personnalisée"
      }
    },
    tours: {
      title: "Excursions Populaires",
      subtitle: "Des expériences sur mesure pour découvrir le meilleur de Bali",
      duration: "Durée",
      from: "À partir de",
      bookNow: "Réserver",
      includes: "Inclus",
      highlights: "Points Forts"
    },
    areas: {
      title: "Explorer Bali par Région",
      subtitle: "Découvrez des expériences uniques dans chaque coin de l'île",
      south: {
        name: "Sud de Bali",
        description: "Plages, temples et vie nocturne animée"
      },
      north: {
        name: "Nord de Bali",
        description: "Cascades, dauphins et retraites paisibles"
      },
      east: {
        name: "Est de Bali",
        description: "Temples anciens et villages traditionnels"
      },
      west: {
        name: "Ouest de Bali",
        description: "Parcs nationaux et nature préservée"
      }
    },
    drivers: {
      title: "Chauffeurs Professionnels",
      subtitle: "Choisissez le chauffeur idéal pour votre voyage",
      english: "Chauffeur Anglophone",
      french: "Chauffeur Francophone",
      englishGuide: "Chauffeur + Guide Anglophone",
      frenchGuide: "Chauffeur + Guide Francophone"
    },
    testimonials: {
      title: "Ce que Disent Nos Clients",
      subtitle: "Témoignages authentiques de voyageurs satisfaits"
    },
    gallery: {
      title: "Galerie de Bali",
      subtitle: "Aperçu du paradis qui vous attend"
    },
    faq: {
      title: "Questions Fréquentes",
      subtitle: "Tout ce que vous devez savoir avant votre voyage"
    },
    contact: {
      title: "Contactez-Nous",
      subtitle: "Prêt à planifier votre aventure balinaise ? Contactez-nous aujourd'hui !",
      email: "Email",
      whatsapp: "WhatsApp",
      address: "Adresse"
    },
    footer: {
      description: "Votre partenaire de confiance pour les excursions et transferts à Bali. Chauffeurs professionnels anglophones et francophones à votre service.",
      quickLinks: "Liens Rapides",
      services: "Services",
      contact: "Coordonnées",
      rights: "Tous droits réservés."
    },
    cta: {
      title: "Prêt pour Votre Aventure à Bali ?",
      subtitle: "Réservez votre excursion ou transfert aujourd'hui et créez des souvenirs inoubliables",
      button: "Contactez-Nous"
    }
  }
};

export const tours = [
  {
    id: 1,
    slug: "ubud-tour",
    image: "https://images.unsplash.com/photo-1480996408299-fc0e830b5db1?w=800&q=80",
    duration: "8-10 hours",
    price: 65,
    area: "central",
    en: {
      name: "Ubud Cultural Tour",
      description: "Discover the heart of Bali's culture with visits to sacred temples, stunning rice terraces, and traditional art villages.",
      highlights: ["Tegallalang Rice Terraces", "Sacred Monkey Forest", "Tirta Empul Temple", "Traditional Art Villages", "Lunch with Valley View"]
    },
    fr: {
      name: "Excursion Culturelle d'Ubud",
      description: "Découvrez le cœur de la culture balinaise avec des visites de temples sacrés, de rizières en terrasses et de villages d'artisans.",
      highlights: ["Rizières de Tegallalang", "Forêt des Singes Sacrés", "Temple Tirta Empul", "Villages d'Artisans", "Déjeuner Vue Vallée"]
    }
  },
  {
    id: 2,
    slug: "uluwatu-sunset",
    image: "https://images.unsplash.com/photo-1604842937136-1648761a6256?w=800&q=80",
    duration: "5-6 hours",
    price: 55,
    area: "south",
    en: {
      name: "Uluwatu Temple & Kecak Dance",
      description: "Experience a magical sunset at the clifftop Uluwatu Temple followed by the traditional Kecak fire dance performance.",
      highlights: ["Uluwatu Temple", "Stunning Cliff Views", "Kecak Fire Dance", "Sunset Over Ocean", "Seafood Dinner Option"]
    },
    fr: {
      name: "Temple d'Uluwatu & Danse Kecak",
      description: "Vivez un coucher de soleil magique au temple d'Uluwatu suivi du spectacle traditionnel de danse Kecak.",
      highlights: ["Temple d'Uluwatu", "Vues Spectaculaires", "Danse du Feu Kecak", "Coucher de Soleil", "Dîner Fruits de Mer"]
    }
  },
  {
    id: 3,
    slug: "nusa-penida",
    image: "https://images.unsplash.com/photo-1729605411119-185103cba74a?w=800&q=80",
    duration: "10-12 hours",
    price: 85,
    area: "island",
    en: {
      name: "Nusa Penida Day Trip",
      description: "Explore the stunning island of Nusa Penida with its dramatic cliffs, crystal-clear waters, and iconic viewpoints.",
      highlights: ["Kelingking Beach", "Angel's Billabong", "Broken Beach", "Crystal Bay", "Fast Boat Transfer"]
    },
    fr: {
      name: "Excursion Nusa Penida",
      description: "Explorez l'île spectaculaire de Nusa Penida avec ses falaises dramatiques et ses eaux cristallines.",
      highlights: ["Plage Kelingking", "Angel's Billabong", "Broken Beach", "Crystal Bay", "Bateau Rapide"]
    }
  },
  {
    id: 4,
    slug: "mount-batur-sunrise",
    image: "https://images.pexels.com/photos/3254728/pexels-photo-3254728.jpeg?w=800",
    duration: "8-10 hours",
    price: 75,
    area: "north",
    en: {
      name: "Mount Batur Sunrise Trek",
      description: "Witness a breathtaking sunrise from the summit of Mount Batur, an active volcano with panoramic views.",
      highlights: ["Sunrise at Summit", "Active Volcano", "Hot Spring Bath", "Breakfast at Top", "Coffee Plantation Visit"]
    },
    fr: {
      name: "Lever de Soleil Mont Batur",
      description: "Admirez un lever de soleil époustouflant depuis le sommet du Mont Batur, un volcan actif.",
      highlights: ["Lever de Soleil au Sommet", "Volcan Actif", "Sources Chaudes", "Petit-déjeuner au Sommet", "Plantation de Café"]
    }
  },
  {
    id: 5,
    slug: "water-temples",
    image: "https://images.unsplash.com/photo-1680094513268-b93865fa0685?w=800&q=80",
    duration: "8-10 hours",
    price: 70,
    area: "east",
    en: {
      name: "Sacred Water Temples Tour",
      description: "Visit Bali's most sacred water temples including Tirta Empul and Tirta Gangga for spiritual purification.",
      highlights: ["Tirta Empul Purification", "Tirta Gangga Palace", "Lempuyang Temple", "Traditional Blessing", "Local Guide"]
    },
    fr: {
      name: "Temples d'Eau Sacrés",
      description: "Visitez les temples d'eau les plus sacrés de Bali pour une purification spirituelle traditionnelle.",
      highlights: ["Purification Tirta Empul", "Palais Tirta Gangga", "Temple Lempuyang", "Bénédiction Traditionnelle", "Guide Local"]
    }
  },
  {
    id: 6,
    slug: "north-bali",
    image: "https://images.unsplash.com/photo-1535262412227-85541e910204?w=800&q=80",
    duration: "10-12 hours",
    price: 80,
    area: "north",
    en: {
      name: "North Bali Adventure",
      description: "Discover the serene north coast with twin lakes, majestic waterfalls, and the famous Ulun Danu temple.",
      highlights: ["Ulun Danu Beratan Temple", "Gitgit Waterfall", "Twin Lakes View", "Dolphin Watching", "Hot Springs"]
    },
    fr: {
      name: "Aventure Nord de Bali",
      description: "Découvrez la côte nord sereine avec ses lacs jumeaux, cascades majestueuses et le célèbre temple Ulun Danu.",
      highlights: ["Temple Ulun Danu Beratan", "Cascade Gitgit", "Vue Lacs Jumeaux", "Observation Dauphins", "Sources Chaudes"]
    }
  }
];

export const transfers = [
  {
    id: 1,
    en: { name: "Airport to South Bali", description: "Kuta, Seminyak, Legian, Canggu" },
    fr: { name: "Aéroport vers Sud Bali", description: "Kuta, Seminyak, Legian, Canggu" },
    price: 25,
    duration: "30-60 min"
  },
  {
    id: 2,
    en: { name: "Airport to Ubud", description: "Central Bali, Rice Terraces Area" },
    fr: { name: "Aéroport vers Ubud", description: "Centre Bali, Zone Rizières" },
    price: 35,
    duration: "1-1.5 hours"
  },
  {
    id: 3,
    en: { name: "Airport to Sanur", description: "East Coast, Nusa Dua Area" },
    fr: { name: "Aéroport vers Sanur", description: "Côte Est, Zone Nusa Dua" },
    price: 30,
    duration: "30-45 min"
  },
  {
    id: 4,
    en: { name: "Airport to Uluwatu", description: "Bukit Peninsula, Southern Cliffs" },
    fr: { name: "Aéroport vers Uluwatu", description: "Péninsule Bukit, Falaises Sud" },
    price: 35,
    duration: "45-60 min"
  },
  {
    id: 5,
    en: { name: "Airport to Amed", description: "East Bali, Diving Area" },
    fr: { name: "Aéroport vers Amed", description: "Est Bali, Zone Plongée" },
    price: 65,
    duration: "2.5-3 hours"
  },
  {
    id: 6,
    en: { name: "Airport to Lovina", description: "North Bali, Dolphin Area" },
    fr: { name: "Aéroport vers Lovina", description: "Nord Bali, Zone Dauphins" },
    price: 75,
    duration: "3-3.5 hours"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    country: "Australia",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
    en: "Amazing experience! Our French-speaking driver was incredibly knowledgeable and made our Ubud tour unforgettable. Highly recommended!",
    fr: "Expérience incroyable ! Notre chauffeur francophone était très compétent et a rendu notre visite d'Ubud inoubliable. Hautement recommandé !"
  },
  {
    id: 2,
    name: "Pierre Dubois",
    country: "France",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
    en: "Perfect service from start to finish. The driver was punctual, the car was comfortable, and the tour was excellent.",
    fr: "Service parfait du début à la fin. Le chauffeur était ponctuel, la voiture confortable et l'excursion excellente."
  },
  {
    id: 3,
    name: "Emma Wilson",
    country: "UK",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80",
    en: "We booked the Mount Batur sunrise trek and it was the highlight of our trip. The guide was professional and very friendly.",
    fr: "Nous avons réservé le trek au Mont Batur et c'était le point fort de notre voyage. Le guide était professionnel et très sympathique."
  },
  {
    id: 4,
    name: "Jean-Marc Laurent",
    country: "Belgium",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80",
    en: "Excellent French-speaking guide who knew Bali inside out. The Nusa Penida trip was perfectly organized.",
    fr: "Excellent guide francophone qui connaissait Bali parfaitement. Le voyage à Nusa Penida était parfaitement organisé."
  }
];

export const faqs = [
  {
    id: 1,
    en: {
      question: "What languages do your drivers speak?",
      answer: "We offer drivers who speak English, French, or drivers with professional English or French-speaking guides for a more in-depth experience."
    },
    fr: {
      question: "Quelles langues parlent vos chauffeurs ?",
      answer: "Nous proposons des chauffeurs anglophones, francophones, ou des chauffeurs avec des guides professionnels anglophones ou francophones pour une expérience plus approfondie."
    }
  },
  {
    id: 2,
    en: {
      question: "How do I book a tour or transfer?",
      answer: "You can book directly via WhatsApp at +62 87862019000 or email us at info@baliautotour.com. We'll respond within 24 hours with confirmation and details."
    },
    fr: {
      question: "Comment réserver une excursion ou un transfert ?",
      answer: "Vous pouvez réserver directement via WhatsApp au +62 87862019000 ou par email à info@baliautotour.com. Nous répondrons sous 24 heures avec confirmation et détails."
    }
  },
  {
    id: 3,
    en: {
      question: "What is included in the tour price?",
      answer: "Our tour prices include private air-conditioned vehicle, professional driver or guide, fuel, parking fees, and mineral water. Entrance fees and meals are usually not included unless specified."
    },
    fr: {
      question: "Qu'est-ce qui est inclus dans le prix de l'excursion ?",
      answer: "Nos prix incluent un véhicule privé climatisé, un chauffeur ou guide professionnel, le carburant, les frais de parking et l'eau minérale. Les frais d'entrée et repas ne sont généralement pas inclus sauf mention contraire."
    }
  },
  {
    id: 4,
    en: {
      question: "Can I customize my tour itinerary?",
      answer: "Absolutely! All our tours can be customized to your preferences. Just let us know what you'd like to see and we'll create a personalized itinerary for you."
    },
    fr: {
      question: "Puis-je personnaliser mon itinéraire ?",
      answer: "Absolument ! Toutes nos excursions peuvent être personnalisées selon vos préférences. Dites-nous ce que vous aimeriez voir et nous créerons un itinéraire sur mesure."
    }
  },
  {
    id: 5,
    en: {
      question: "What payment methods do you accept?",
      answer: "We accept cash payment (IDR, USD, EUR) at the end of your tour or transfer. For advance bookings, we can arrange bank transfer or other payment methods."
    },
    fr: {
      question: "Quels modes de paiement acceptez-vous ?",
      answer: "Nous acceptons le paiement en espèces (IDR, USD, EUR) à la fin de votre excursion ou transfert. Pour les réservations anticipées, nous pouvons organiser un virement bancaire."
    }
  },
  {
    id: 6,
    en: {
      question: "What is your cancellation policy?",
      answer: "Free cancellation up to 24 hours before your scheduled tour or transfer. Cancellations within 24 hours may incur a 50% charge."
    },
    fr: {
      question: "Quelle est votre politique d'annulation ?",
      answer: "Annulation gratuite jusqu'à 24 heures avant votre excursion ou transfert prévu. Les annulations dans les 24 heures peuvent entraîner des frais de 50%."
    }
  }
];

export const galleryImages = [
  { id: 1, src: "https://images.unsplash.com/photo-1559998560-deb30d24ea50?w=600&q=80", alt: "Bali Temple" },
  { id: 2, src: "https://images.unsplash.com/photo-1480996408299-fc0e830b5db1?w=600&q=80", alt: "Rice Terraces" },
  { id: 3, src: "https://images.unsplash.com/photo-1603477849227-705c424d1d80?w=600&q=80", alt: "Bali Beach" },
  { id: 4, src: "https://images.unsplash.com/photo-1704253411612-e4deb715dcd8?w=600&q=80", alt: "Ulun Danu Temple" },
  { id: 5, src: "https://images.unsplash.com/photo-1604842937136-1648761a6256?w=600&q=80", alt: "Uluwatu Temple" },
  { id: 6, src: "https://images.unsplash.com/photo-1609412058473-c199497c3c5d?w=600&q=80", alt: "Golden Rice Terraces" },
  { id: 7, src: "https://images.unsplash.com/photo-1535262412227-85541e910204?w=600&q=80", alt: "Bali Waters" },
  { id: 8, src: "https://images.unsplash.com/photo-1680094513268-b93865fa0685?w=600&q=80", alt: "Water Temple" }
];

export const areas = [
  {
    id: "south",
    image: "https://images.unsplash.com/photo-1603477849227-705c424d1d80?w=600&q=80",
    en: {
      name: "South Bali",
      description: "Home to famous beaches, vibrant nightlife, and iconic temples like Uluwatu. Perfect for surfers and sunset lovers.",
      highlights: ["Kuta Beach", "Seminyak", "Uluwatu Temple", "Jimbaran Bay", "Nusa Dua"]
    },
    fr: {
      name: "Sud de Bali",
      description: "Célèbre pour ses plages, sa vie nocturne animée et ses temples emblématiques comme Uluwatu. Parfait pour les surfeurs.",
      highlights: ["Plage de Kuta", "Seminyak", "Temple d'Uluwatu", "Baie de Jimbaran", "Nusa Dua"]
    }
  },
  {
    id: "north",
    image: "https://images.pexels.com/photos/3254728/pexels-photo-3254728.jpeg?w=600",
    en: {
      name: "North Bali",
      description: "Tranquil volcanic lakes, stunning waterfalls, and dolphin watching. A peaceful escape from the busy south.",
      highlights: ["Lovina Beach", "Gitgit Waterfall", "Lake Beratan", "Hot Springs", "Dolphin Tours"]
    },
    fr: {
      name: "Nord de Bali",
      description: "Lacs volcaniques tranquilles, cascades et observation des dauphins. Une évasion paisible du sud animé.",
      highlights: ["Plage de Lovina", "Cascade Gitgit", "Lac Beratan", "Sources Chaudes", "Tours Dauphins"]
    }
  },
  {
    id: "east",
    image: "https://images.unsplash.com/photo-1680094513268-b93865fa0685?w=600&q=80",
    en: {
      name: "East Bali",
      description: "Ancient temples, traditional villages, and the majestic Mount Agung. Rich in culture and spirituality.",
      highlights: ["Tirta Gangga", "Lempuyang Temple", "Amed Beach", "Candidasa", "Mount Agung"]
    },
    fr: {
      name: "Est de Bali",
      description: "Temples anciens, villages traditionnels et le majestueux Mont Agung. Riche en culture et spiritualité.",
      highlights: ["Tirta Gangga", "Temple Lempuyang", "Plage d'Amed", "Candidasa", "Mont Agung"]
    }
  },
  {
    id: "west",
    image: "https://images.unsplash.com/photo-1513415756790-2ac1db1297d0?w=600&q=80",
    en: {
      name: "West Bali",
      description: "Untouched nature, national parks, and pristine diving spots. Ideal for nature lovers and adventurers.",
      highlights: ["West Bali National Park", "Menjangan Island", "Tanah Lot Temple", "Medewi Beach", "Jatiluwih"]
    },
    fr: {
      name: "Ouest de Bali",
      description: "Nature préservée, parcs nationaux et spots de plongée vierges. Idéal pour les amoureux de la nature.",
      highlights: ["Parc National de l'Ouest", "Île Menjangan", "Temple Tanah Lot", "Plage Medewi", "Jatiluwih"]
    }
  }
];